// @flow -strict
import * as React from 'react';
import classNames from 'classnames';
import Button from './Button';

import './ExpandButtonWithText.css';
import ShowMoreText from '../tabs/collections/ShowMoreText';

type Props = {
  text: string,
  isExpanded: boolean,
  showHighLight: boolean,
  onClick: (isExapled: boolean) => void,
  withTooltip ?: boolean,
  reverse ?: boolean
};

export default class ExpandButtonWithText extends React.PureComponent<Props, {}> {

  onClick = (e) => {
    if (this.props.onClick) this.props.onClick(e);
  };
  render() {
    const { text, isExpanded, showHighLight, withTooltip, reverse } = this.props;
    const toolTip = withTooltip ? true : false;
    return (
      <div name="ExpandButtonWithText" className={classNames('align-center', `${reverse?'reverse-exp-btn':'flex-row'}`,{ expanded: isExpanded })}>
        <Button
          className={classNames('ExpandButton', { expanded: isExpanded })}
          icon="images/triangle_gray.svg"
          onClick={this.onClick}
        />
        <Button type="PLAIN" title={toolTip ? text : null} text={text} onClick={this.onClick} labelClass={showHighLight ? 'high-light' : null} />
      </div>
    );
  }
}

type ExpandButtonWithTextSeeMoreProps = {
  onClick: (isExapled: boolean) => void,
  isExpanded: Boolean,
  text: string
};

export const ExpandButtonWithTextSeeMore = function(props: ExpandButtonWithTextSeeMoreProps) {
  return (
    <div name="ExpandButtonWithText" className={classNames('flex-row align-center', { expanded: props.isExpanded })}>
      <Button
        className={classNames('ExpandButton', { expanded: props.isExpanded })}
        icon="images/triangle_gray.svg"
        onClick={() => {
          if (props.onClick) props.onClick(props.isExpanded);
        }}
      />
      <div
        className="ShowMoretextButton"
        onClick={() => {
          if (props.onClick) props.onClick(props.isExpanded);
        }}>
        <ShowMoreText lines={2}>
          <div style={{ width: '200px' }}>{props.text}</div>
        </ShowMoreText>
      </div>
    </div>
  );
};
